/**
 * The call status pill and the review pill (docs/plans/oncall-line-plan.md
 * 7.7): the design system's status-pill recipe, a word plus an icon, never
 * colour alone.
 */
import type { OncallCallStatus, OncallReviewStatus } from '../../api/oncallApi';
import { reviewMeta, statusMeta } from './callMeta';

const PILL = 'inline-flex items-center gap-1 whitespace-nowrap rounded-full px-2.5 py-0.5 text-xs font-medium';

export function CallStatusPill({ status }: { status: OncallCallStatus | string | null | undefined }) {
  const meta = statusMeta(status);
  const Icon = meta.Icon;
  return (
    <span className={`${PILL} ${meta.cls}`} title={meta.hint} data-testid="oncall-call-status">
      <Icon className="h-3.5 w-3.5 flex-shrink-0" aria-hidden="true" />
      {meta.label}
    </span>
  );
}

export function ReviewPill({ review }: { review: OncallReviewStatus | string | null | undefined }) {
  const meta = reviewMeta(review);
  const Icon = meta.Icon;
  return (
    <span className={`${PILL} ${meta.cls}`} title={meta.hint} data-testid="oncall-call-review">
      <Icon className="h-3.5 w-3.5 flex-shrink-0" aria-hidden="true" />
      {meta.label}
    </span>
  );
}
